import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { take, tap, switchMap, mapTo } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { ThemeLoaderService } from '@awp/theme';
import { isNullOrEmpty } from '@awp/core/utils';

@Injectable({
  providedIn: 'root'
})
export class RootThemeResolver implements Resolve<any> {

  constructor(private contentProvider: ContentProvider, private themeLoader: ThemeLoaderService) { }

  resolve(): Observable<any> {
    return this.contentProvider.fetchRoot().pipe(
        take(1),
        tap(p => {
          if (!isNullOrEmpty(p.pageTitle)) {
            this.themeLoader.setTitle(p.pageTitle);
          }
          if (p.favIcon != null) {
            this.themeLoader.setFavIcon(p.favIcon.href);
          }
        }),
        switchMap(p => {
          if (p.theme != null) {
            return from(this.themeLoader.setCssNode('theme-css', p.theme.href))
                    .pipe(mapTo(p))
          }
          return of(p);
        })
      );
  }
}